const management = () => import('@/views/main/management/management.vue')
export default {
  path: '/main/management',
  name: 'management',
  component: management,
  children: []
}
